import {api} from 'helpers/api';
import {success, error} from 'helpers/response';

export const confirmEmailCheck = (data) => async (dispatch) => {
    try {
        const response = await api.mobile.confirmEmailCheck(data);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const confirmEmailChangeCheck = (data) => async (dispatch) => {
    try {
        const response = await api.mobile.confirmEmailChangeCheck(data);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/mobile.js